import React from 'react';

export const EDUIcon = () => {
  return (
    <div>
      <img src="/pictures/EDUIcon.svg" alt="" />
    </div>
  );
};
